function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.announcmentBar = this.announcmentBar || document.querySelector('.announcement-bar-section');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.announcmentBar.getBoundingClientRect().bottom)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => {
          this.announcementBarArrowButtonWasClicked = true;
        }, {once: true});
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');


        // Custom discounted price from the Recharge widget
        const customPrice = price.querySelector('.enavi-custom-discount-price');
        const rcDiscountedPriceEl = document.querySelector('.rc-radio__price');
        let mainPriceContainer = document.querySelector(".product__info-container");

        if(mainPriceContainer.classList.contains('has-custom-price')){
          if(rcDiscountedPriceEl && customPrice){
            let rcDiscountedPrice = rcDiscountedPriceEl.textContent;
            customPrice.textContent = rcDiscountedPrice;
          }
        }

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);



/* ------------ ENAVI SUBSCRIPTION LAYOUT JS ------------ */
const executeSubscriptionLayoutScript = (isDynamicallyLoaded) => {

  const syncRcVariantHighlights = () => {
    document.querySelectorAll('.rc-widget .product-form__input label[for]').forEach((label) => {
      const id = label.getAttribute('for');
      const input = id ? document.getElementById(id) : null;
      label.classList.toggle('checked', !!input && input.checked);
    });
  };

  const updateVariantLabelCheckedState = (root) => {
    if (!root) return;

    root.querySelectorAll('.product-form__input').forEach((group) => {
      const radios = group.querySelectorAll('input[type="radio"]');
      let hasChecked = false;

      radios.forEach((radio) => {
        const label = group.querySelector(`label[for="${radio.id}"]`);
        const wrapper = label ? label.closest('.product-form__input-wrapper') : null;
        if (!label) return;

        const isChecked = radio.checked || radio.hasAttribute('checked');
        label.classList.toggle('checked', isChecked);
        if (wrapper) wrapper.classList.toggle('checked', isChecked);
        if (isChecked) hasChecked = true;
      });

      if (!hasChecked && radios.length) {
        const fallbackRadio = radios[0];
        fallbackRadio.checked = true;
        fallbackRadio.setAttribute('checked', 'checked');
        const fallbackLabel = group.querySelector(`label[for="${fallbackRadio.id}"]`);
        if (fallbackLabel) {
          fallbackLabel.classList.add('checked');
          const fallbackWrapper = fallbackLabel.closest('.product-form__input-wrapper');
          if (fallbackWrapper) fallbackWrapper.classList.add('checked');
        }
      }
    });
  };

  const ensureVariantLabelAndWrapperSync = (root) => {
    try {
      const scope = root || document;
      scope.querySelectorAll('.product-form__input').forEach((group) => {
        group.querySelectorAll('.product-form__input-wrapper').forEach((wrap) => {
          const input = wrap.previousElementSibling && wrap.previousElementSibling.matches && wrap.previousElementSibling.matches('input[type="radio"]')
            ? wrap.previousElementSibling
            : wrap.querySelector('input[type="radio"]');
          const label = wrap.querySelector('label[for]');
          const isChecked = !!(input && input.checked);
          if (wrap) wrap.classList.toggle('checked', isChecked);
          if (label) label.classList.toggle('checked', isChecked);
        });
      });
    } catch (e) {}
  };

  const resetVariantLabelCheckedState = (root) => {
    try {
      const scope = root || document;
      scope.querySelectorAll('.product-form__input .product-form__input-wrapper.checked').forEach((w) => w.classList.remove('checked'));
      scope.querySelectorAll('.product-form__input label.checked').forEach((l) => l.classList.remove('checked'));
    } catch (e) {}
  };

  const scheduleLabelSync = (root) => {
    try {
      const target = root || document;
      requestAnimationFrame(() => {
        ensureVariantLabelAndWrapperSync(target);
        requestAnimationFrame(() => {
          ensureVariantLabelAndWrapperSync(target);
        });
      });
    } catch (e) {}
  };

  const syncVariantSelectionFromOriginal = (targetRoot) => {
    if (!targetRoot) return;
    const originalRoot = document.querySelector('variant-radios');
    if (!originalRoot) return;

    const activeOriginal = originalRoot.querySelector('input[type="radio"]:checked');
    const activeValue = activeOriginal ? activeOriginal.value : null;

    targetRoot.querySelectorAll('.product-form__input').forEach((group) => {
      group.querySelectorAll('input[type="radio"]').forEach((radio) => {
        const matches = activeValue && (radio.value === activeValue || radio.dataset.variantValue === activeValue);
        radio.checked = !!matches;
        if (matches) radio.setAttribute('checked', 'checked');
        else radio.removeAttribute('checked');
      });
    });

    updateVariantLabelCheckedState(targetRoot);
  };

  const markVariantLabelChecked = (container, radio) => {
    if (!container || !radio) return;
    const group = radio.closest('.product-form__input');
    if (!group) return;
    group.querySelectorAll('.product-form__input-wrapper').forEach((wrap) => wrap.classList.remove('checked'));
    group.querySelectorAll('label.checked').forEach((label) => label.classList.remove('checked'));

    const label = container.querySelector(`label[for="${radio.id}"]`);
    if (!label) return;
    label.classList.add('checked');
    const wrapper = label.closest('.product-form__input-wrapper');
    if (wrapper) wrapper.classList.add('checked');
  };

  if (!window.__rcVariantHighlightChangeBound) {
    document.addEventListener('change', (event) => {
      const target = event.target;
      if (target && target instanceof HTMLInputElement && target.type === 'radio' && target.closest('.rc-widget')) {
        const widgetRoot = target.closest('.rc-widget');
        syncRcVariantHighlights();
        updateVariantLabelCheckedState(widgetRoot || document);
      }
    });
    window.__rcVariantHighlightChangeBound = true;
  }

  const bindKeyboardToLabels = (root = document) => {
    try {
      const getAssociatedRadio = (label) => {
        if (!label) return null;
        const forId = label.getAttribute('for');
        if (forId) {
          const byId = document.getElementById(forId);
          if (byId && byId.type === 'radio') return byId;
        }
        const within = label.querySelector('input[type="radio"]');
        return within || null;
      };

      // Mirror radio input focus to labels for visual focus indication
      const mirrorFocusToLabel = (radio) => {
        if (!radio || radio.dataset.kbFocusBound === 'true') return;
        const focusHandler = () => {
          if (radio.closest('.rc-widget')) {
            const rcLabel = radio.closest('label.rc-radio');
            if (rcLabel) rcLabel.classList.add('rc-kb-focused');
          } else {
            const id = radio.id;
            let lbl = null;
            if (id) lbl = root.querySelector(`label[for="${CSS.escape(id)}"]`);
            if (lbl) lbl.classList.add('focused');
          }
        };
        const blurHandler = () => {
          if (radio.closest('.rc-widget')) {
            const rcLabel = radio.closest('label.rc-radio');
            if (rcLabel) rcLabel.classList.remove('rc-kb-focused');
          } else {
            const id = radio.id;
            let lbl = null;
            if (id) lbl = root.querySelector(`label[for="${CSS.escape(id)}"]`);
            if (lbl) lbl.classList.remove('focused');
          }
        };
        radio.addEventListener('focus', focusHandler);
        radio.addEventListener('blur', blurHandler);
        radio.dataset.kbFocusBound = 'true';
      };

      root.querySelectorAll('input[type="radio"]').forEach(mirrorFocusToLabel);

      // Keep 'checked' class synced after keyboard or programmatic changes
      const changeHandler = (ev) => {
        const changedRadio = ev.target;
        if (!changedRadio || changedRadio.type !== 'radio') return;
        const selectedVariantValue = changedRadio.getAttribute('data-variant-value') || changedRadio.value;
        if (!selectedVariantValue) return;
        const selectedId = changedRadio.id;
        const rootToReset = document.querySelector('.rc-widget') || document;
        resetVariantLabelCheckedState(rootToReset);
        if (selectedId) {
          document.querySelectorAll(`.rc-widget .product-form__input-wrapper label[for="${selectedId}"]`).forEach((labelEl) => labelEl.classList.add('checked'));
          document.querySelectorAll(`.rc-widget .product-form__input-wrapper label[for="${selectedId}"]`).forEach((labelEl) => {
            const wrap = labelEl.closest('.product-form__input-wrapper');
            if (wrap) wrap.classList.add('checked');
          });
        }
        const changedContainer = changedRadio.closest('.rc-selling-plans, .onetime-radio') || null;
        const allVariantRadios = document.querySelectorAll('.rc-widget input[type="radio"][data-variant-value]');
        allVariantRadios.forEach((variantRadioInput) => {
          const variantValue = variantRadioInput.getAttribute('data-variant-value') || variantRadioInput.value;
          if (variantValue !== selectedVariantValue) return;
          const variantContainer = variantRadioInput.closest('.rc-selling-plans, .onetime-radio') || null;
          if (variantRadioInput === changedRadio) return;
          if (variantRadioInput.checked) return;
          if (changedContainer && variantContainer && changedContainer === variantContainer) return;
          const labelForVariant = variantRadioInput.id
            ? document.querySelector(`.rc-widget .product-form__input-wrapper label[for="${variantRadioInput.id}"]`)
            : null;
          if (labelForVariant && typeof labelForVariant.click === 'function') {
            labelForVariant.click();
          } else if (typeof variantRadioInput.click === 'function') {
            variantRadioInput.click();
          }
        });
        try { ensureVariantLabelAndWrapperSync(document); scheduleLabelSync(document); } catch (e) {}
      };
      if (!root.__kbChangeBound) {
        document.addEventListener('change', changeHandler);
        root.__kbChangeBound = true;
      }

      // Make variant labels focusable (in both subscription and one-time containers) and radios not tabbable
      root.querySelectorAll('.product-form__input label[for], .rc-widget .product-form__input-wrapper label[for]').forEach((label) => {
        const radio = getAssociatedRadio(label);
        if (radio && radio.tabIndex !== -1) radio.tabIndex = -1;
        if (!label.hasAttribute('tabindex')) label.setAttribute('tabindex', '0');
        if (label.dataset.kbBound === 'true') return;
        label.addEventListener('keydown', (ev) => {
          if (ev.key !== 'Enter') return;
          ev.preventDefault();
          const input = getAssociatedRadio(label);
          if (input && !input.disabled) {
            input.click();
            try { input.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
            if (input.id) {
              document.querySelectorAll('.product-form__input label').forEach((l) => l.classList.remove('checked'));
              document.querySelectorAll(`.product-form__input label[for="${input.id}"]`).forEach((l) => l.classList.add('checked'));
            }
          }
        });
        label.dataset.kbBound = 'true';
      });

      // Make Recharge purchase option labels focusable and radios not tabbable to avoid double-tab
      root.querySelectorAll('.rc-widget label.rc-radio[for]').forEach((label) => {
        const radio = getAssociatedRadio(label);
        if (radio && radio.tabIndex !== -1) radio.tabIndex = -1;
        if (!label.hasAttribute('tabindex')) label.setAttribute('tabindex', '0');
        if (label.dataset.kbBound === 'true') return;
        label.addEventListener('keydown', (ev) => {
          if (ev.key !== 'Enter') return;
          ev.preventDefault();
          const input = getAssociatedRadio(label);
          if (input && !input.disabled) {
            input.click();
            try { input.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
          }
        });
        label.dataset.kbBound = 'true';
      });
    } catch (e) {}
  };

  /* ------------ ENAVI MOVE VARIANT OPTIONS JS ------------ */
  const subscriptionRadioInputs = document.querySelectorAll('.recharge-subscription-widget .rc-radio__input');
  if (subscriptionRadioInputs.length > 0) {

    const ensureSubscriptionHeaderLayout = () => {
      try {
        const subscriptionRoot = document.querySelector('.subscription-radio');
        if (!subscriptionRoot) return;
        const labelContainer = subscriptionRoot.querySelector('.rc-radio__label');
        if (!labelContainer) return;

        let leftWrap = labelContainer.querySelector('.rc-radio__left');
        if (!leftWrap) {
          leftWrap = document.createElement('span');
          leftWrap.className = 'rc-radio__left';
          labelContainer.insertAdjacentElement('afterbegin', leftWrap);
        }

        const inputEl = subscriptionRoot.querySelector('.rc-radio__input');
        if (inputEl && inputEl.parentElement !== leftWrap) {
          leftWrap.appendChild(inputEl);
        }

        const subText = labelContainer.querySelector('.rc-radio__subscription-custom');
        if (subText && subText.parentElement !== leftWrap) {
          leftWrap.appendChild(subText);
        }
      } catch (e) {
      }
    };

    let enaviPriceSync = { rAFId: 0, lastText: '' };
    const scheduleRechargeOnetimePriceSync = () => {
      if (enaviPriceSync.rAFId) return;
      enaviPriceSync.rAFId = window.requestAnimationFrame(() => {
        enaviPriceSync.rAFId = 0;
        try {
          ensureSubscriptionHeaderLayout();
          const subscriptionLabel = document.querySelector('.subscription-radio .rc-radio__label');
          const subscriptionPriceEl = subscriptionLabel && subscriptionLabel.querySelector('.rc-radio__price');
          if (!subscriptionLabel || !subscriptionPriceEl) return;

          let priceWrap = subscriptionLabel.querySelector('.rc-radio__price-wrap');
          if (!priceWrap) {
            priceWrap = document.createElement('span');
            priceWrap.className = 'rc-radio__price-wrap';
            subscriptionPriceEl.insertAdjacentElement('beforebegin', priceWrap);
            priceWrap.appendChild(subscriptionPriceEl);
          }

          const priceRoot = document.querySelector('.product__info-container .price');
          if (!priceRoot) return;
          const salePriceEl = priceRoot.querySelector('.price-item--sale');
          const regularPriceEl = priceRoot.querySelector('.price-item--regular');
          const oneTimePriceText = ((salePriceEl && salePriceEl.textContent) || (regularPriceEl && regularPriceEl.textContent) || '').trim();
          if (!oneTimePriceText || oneTimePriceText === enaviPriceSync.lastText) return;

          let onetimeEl = priceWrap.querySelector('.rc-radio__onetime-price');
          if (!onetimeEl) {
            onetimeEl = document.createElement('span');
            onetimeEl.className = 'rc-radio__onetime-price';
            priceWrap.appendChild(onetimeEl);
          }
          onetimeEl.textContent = oneTimePriceText;
          enaviPriceSync.lastText = oneTimePriceText;
        } catch (e) {
        }
      });
    };

    const variantRadiosSource = document.querySelector('variant-radios');
    const variantOptionsWithoutBenefits = (() => {
      if (!variantRadiosSource) return '';
      const copy = variantRadiosSource.cloneNode(true);
      copy.querySelectorAll('.subscription-benefits').forEach((n) => n.remove());
      return copy.innerHTML;
    })();
    const subscriptionBenefitsHTML = (() => {
      if (!variantRadiosSource) return '';
      const node = variantRadiosSource.querySelector('.subscription-benefits');
      return node;
    })();

    const normalizeVariantOptionGroup = (container, suffix) => {
      try {
        if (!container) return;
        const radios = container.querySelectorAll('.product-form__input input[type="radio"]');
        radios.forEach((radio) => {
          const wasChecked = radio.checked || radio.hasAttribute('checked');
          if (radio.dataset.mirrored === 'true') return;
          radio.dataset.mirrored = 'true';
          const originalId = radio.id;
          if (originalId) {
            const newId = `${originalId}-${suffix}`;
            radio.id = newId;
            const lbl = container.querySelector(`label[for="${originalId}"]`);
            if (lbl) lbl.setAttribute('for', newId);
          }
          if (radio.name) {
            radio.name = `${radio.name}__${suffix}`;
          }
          radio.setAttribute('data-variant-value', radio.value);
          if (wasChecked) {
            radio.checked = true;
            radio.setAttribute('checked', 'checked');
          } else {
            radio.removeAttribute('checked');
          }
        });

        if (container.dataset.mirrorListenerAttached !== 'true') {
          container.addEventListener('change', (ev) => {
            const target = ev.target;
            if (!target || target.type !== 'radio') return;
            const variantValue = target.value;

            const otherContainer = suffix === 'one'
              ? document.querySelector('.rc-selling-plans')
              : document.querySelector('.onetime-radio');

            if (otherContainer) {
              const otherGroup = otherContainer.querySelector('.product-form__input');
              const candidates = otherContainer.querySelectorAll('.product-form__input input[type="radio"]');
              let otherInput = null;
              candidates.forEach((r) => {
                if (!otherInput && r.value === variantValue) otherInput = r;
              });
              if (otherInput) {
                otherInput.checked = true;
                otherInput.setAttribute('checked', 'checked');
                syncVariantSelectionFromOriginal(otherContainer);
              }
            }

            const originalRoot = document.querySelector('variant-radios');
            if (originalRoot) {
              let originalInput = null;
              originalRoot.querySelectorAll('input[type="radio"]').forEach((r) => {
                if (!originalInput && r.value === variantValue) originalInput = r;
              });
              if (originalInput) {
                originalInput.checked = true;
                originalInput.setAttribute('checked', 'checked');
                updateVariantLabelCheckedState(originalRoot);
                originalInput.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          });
          container.dataset.mirrorListenerAttached = 'true';
        }
      } catch (e) {}
    };

    // Google Analytics helpers
    function getProductIdFromPage() {
      try {
        // Prefer ShopifyAnalytics
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.id) {
          return window.ShopifyAnalytics.meta.product.id;
        }
        // Fallback meta
        if (window.meta && window.meta.product && window.meta.product.id) {
          return window.meta.product.id;
        }
        // From product-info element if available
        const info = document.querySelector('product-info');
        if (info && info.dataset && info.dataset.productId) return info.dataset.productId;
      } catch (e) {}
      return null;
    }

    function getSelectedPurchaseType() {
      try {
        const checked = document.querySelector('.recharge-subscription-widget .rc-radio__input:checked');
        if (!checked) return null;
        return checked.value === 'onetime' ? 'one_time' : 'subscription';
      } catch (e) { return null; }
    }

    function getSelectedSubscriptionPlanName() {
      try {
        const single = document.querySelector('.rc-selling-plans-single');
        if (single && single.textContent) return single.textContent.trim();
        const checked = document.querySelector('.rc-selling-plans input[type="radio"]:checked');
        if (checked) {
          const lbl = checked.nextElementSibling || document.querySelector(`label[for="${checked.id}"]`);
          if (lbl) return lbl.textContent.trim();
        }
      } catch (e) {}
      return null;
    }

    function pushAnalyticsEvent(eventName, params, eventValue) {
      try {
        const payload = Object.assign({}, params || {});
        if (eventValue) payload.event_value = eventValue;
        window.gtag('event', eventName, payload);
        console.log('pushAnalyticsEvent', eventName, payload);
      } catch (e) {}
    }

    try {
      window.GAAnalytics = window.GAAnalytics || {};
      if (typeof window.GAAnalytics.pushEvent !== 'function') {
        window.GAAnalytics.pushEvent = function(eventName, params, eventValue) {
          return pushAnalyticsEvent(eventName, params, eventValue);
        };
      }
    } catch (e) {}

    const getVariantByOptionValue = (value) => {
      try {
        const variantScript = document.querySelector('variant-radios script[type="application/json"]');
        if (!variantScript) return null;
        const variants = JSON.parse(variantScript.textContent || '[]');
        const match = variants.find((v) => (v.public_title || v.title) === value || v.option1 === value || v.title === value);
        return match || null;
      } catch (e) { return null; }
    };

    const getSubscriptionPriceCentsByVariantId = (variantId) => {
      try {
        const subScript = document.querySelector('.subscription-radio script[type="application/json"]');
        if (!subScript) return null;
        const subVariants = JSON.parse(subScript.textContent || '[]');
        const match = subVariants.find((v) => v.id === variantId);
        if (!match || !Array.isArray(match.selling_plan_allocations) || match.selling_plan_allocations.length === 0) return null;
        const alloc = match.selling_plan_allocations[0];
        return (alloc.per_delivery_price || alloc.price || null) || null;
      } catch (e) { return null; }
    };

    const getCurrencyPrefix = () => {
      const rechargePriceEl = document.querySelector('.subscription-radio .rc-radio__price');
      const sample = rechargePriceEl && rechargePriceEl.textContent ? rechargePriceEl.textContent.trim() : '$ 0.00';
      const idx = sample.search(/[0-9]/);
      return idx > 0 ? sample.substring(0, idx).trim() + ' ' : '$ ';
    };

    const formatMoneyFromCents = (cents) => {
      const value = (Math.round(cents) / 100).toFixed(2);
      return value;
    };

    const updatePricePerPouchForContainer = (container, mode) => {
      try {
        if (!container) return;
        const showSub = mode === 'sub';
        const currencyPrefix = getCurrencyPrefix();
        container.querySelectorAll('.product-form__input-wrapper').forEach((wrap) => {
          const priceEl = wrap.querySelector('.price-per-pouch');
          const labelEl = wrap.querySelector('label');
          if (!priceEl || !labelEl) return;
          const dataAttr = showSub ? 'data-pp-sub' : 'data-pp-one';
          const val = priceEl.getAttribute(dataAttr);
          if (val) {
            priceEl.textContent = `${val}/Pouch`.replace('//','/');
          }
        });
      } catch (e) {}
    };

    const addVariantOptions = (input) => {
      if (!input) return;
      let variantOptions = variantOptionsWithoutBenefits;
      let mainPriceContainer = document.querySelector(".product__info-container");

        if(input.checked){
          if(input.value == 'onetime'){
            input.parentElement.classList.add("added-variants");
            input.parentElement.querySelectorAll('.product-form__input').forEach(input => {
              input.remove();
            });
            input.parentElement.insertAdjacentHTML('beforeend', variantOptions);
            document.querySelectorAll('.subscription-benefits').forEach((el)=>el.remove());
            mainPriceContainer.classList.remove("has-custom-price");
            normalizeVariantOptionGroup(input.parentElement, 'one');
            updatePricePerPouchForContainer(input.parentElement, 'one');
            syncVariantSelectionFromOriginal(input.parentElement);
            const checkedRadioOne = input.parentElement.querySelector('.product-form__input input[type="radio"]:checked');
            resetVariantLabelCheckedState(input.parentElement);
            if (checkedRadioOne) markVariantLabelChecked(input.parentElement, checkedRadioOne);
            ensureVariantLabelAndWrapperSync(input.parentElement);
            scheduleLabelSync(input.parentElement);
          }
          else{
              //Discounted Price
            const rcDiscountedPriceEl = document.querySelector('.rc-radio__price')
            if(rcDiscountedPriceEl){
              const discountedPriceEl = document.querySelector('.enavi-custom-discount-price')
              if (discountedPriceEl) {
                let rcDiscountedPrice = rcDiscountedPriceEl.textContent;
                discountedPriceEl.textContent = rcDiscountedPrice;
              }
            }
            mainPriceContainer.classList.add("has-custom-price");
            document.querySelectorAll('.onetime-radio .product-form__input').forEach(input => {
              input.remove();
            });
            const plansContainer1 = document.querySelector('.rc-selling-plans');
            if (plansContainer1){
              plansContainer1.querySelectorAll('.product-form__input').forEach(n => n.remove());
              plansContainer1.insertAdjacentHTML('beforeend', variantOptions);
              normalizeVariantOptionGroup(plansContainer1, 'sub');
              updatePricePerPouchForContainer(plansContainer1, 'sub');
              syncVariantSelectionFromOriginal(plansContainer1);
              const checkedRadioSub = plansContainer1.querySelector('.product-form__input input[type="radio"]:checked');
              resetVariantLabelCheckedState(plansContainer1);
              if (checkedRadioSub) markVariantLabelChecked(plansContainer1, checkedRadioSub);
              ensureVariantLabelAndWrapperSync(plansContainer1);
              scheduleLabelSync(plansContainer1);
            }

            const subRadio = input.closest('.subscription-radio') || input.parentElement;
            const plansContainer2 = document.querySelector('.rc-selling-plans');
            if(plansContainer2){
              plansContainer2.parentElement.querySelectorAll('.subscription-benefits').forEach((n)=>n.remove());
              if(subscriptionBenefitsHTML){
                plansContainer2.appendChild(subscriptionBenefitsHTML);
              }
              updatePricePerPouchForContainer(plansContainer2, 'sub');
              syncVariantSelectionFromOriginal(plansContainer2);
              const checkedRadioSub2 = plansContainer2.querySelector('.product-form__input input[type="radio"]:checked');
              resetVariantLabelCheckedState(plansContainer2);
              if (checkedRadioSub2) markVariantLabelChecked(plansContainer2, checkedRadioSub2);
              ensureVariantLabelAndWrapperSync(plansContainer2);
              scheduleLabelSync(plansContainer2);
            }
            if (subRadio && subRadio.parentElement) {
              const optionLabels = subRadio.parentElement.querySelectorAll('.product-form__input input[type="radio"] + label');
              if(optionLabels.length >= 3 && !optionLabels[2].querySelector('.enavi-badge')){
                optionLabels[2].insertAdjacentHTML('beforeend', '<span class="enavi-badge">Best Value</span>');
              }
            }
          }
          // Keep the subscription header in sync with current one-time price
          scheduleRechargeOnetimePriceSync();
          const rcSellingPlansSingle = document.querySelector('.rc-selling-plans-single');
          if (rcSellingPlansSingle) {
            const rcSellingPlansSingleText = rcSellingPlansSingle.textContent;
            rcSellingPlansSingle.innerText = `(${rcSellingPlansSingleText})`;
            rcSellingPlansSingle.insertAdjacentHTML('beforebegin', '<strong class="rc-selling-plans-single-select">Select Quantity</strong>');
          }


        }
        document.querySelectorAll('.product-form__input label').forEach(label => {
          label.addEventListener('click', () => {
            const value = label.getAttribute('for');

            document.querySelectorAll('.product-form__input label').forEach(otherLabel => {
              otherLabel.classList.remove('checked');
            });

            document.querySelectorAll(`.product-form__input label[for="${value}"]`).forEach(siblingLabel => {
              siblingLabel.classList.add('checked');
            });
            updateVariantLabelCheckedState(document);
          });
          // Make label keyboard actionable and focusable
          if (!label.hasAttribute('tabindex')) label.setAttribute('tabindex', '0');
          if (label.dataset.kbBound !== 'true') {
            label.addEventListener('keydown', (ev) => {
              const isEnter = ev.key === 'Enter';
              const isSpace = ev.key === ' ' || ev.key === 'Spacebar';
              if (!isEnter && !isSpace) return;
              ev.preventDefault();
              const forId = label.getAttribute('for');
              const input = forId ? document.getElementById(forId) : label.querySelector('input[type="radio"]');
              if (input && input.type === 'radio' && !input.disabled) {
                input.click();
                input.focus();
              }
            });
            label.dataset.kbBound = 'true';
          }
        });

        syncRcVariantHighlights();
        updateVariantLabelCheckedState(document);
    }

    subscriptionRadioInputs.forEach(input => input.addEventListener('change', () => {
      const widgetRoot = input.closest('.rc-widget');
      addVariantOptions(input);
      updateVariantLabelCheckedState(widgetRoot || document);
      const productId = getProductIdFromPage();
      if (input.value === 'onetime') {
        pushAnalyticsEvent('buybox_select_one_time', { product_id: productId }, 'Captures user preference for one-time');
      } else {
        const plan = getSelectedSubscriptionPlanName();
        pushAnalyticsEvent('buybox_select_subscription', { product_id: productId, subscription_plan: plan }, 'Captures user preference for subscription');
      }
    }));

    let currentInput = document.querySelector('.rc-radio__input:checked');
    if (currentInput) {
      addVariantOptions(currentInput);
    }

    ensureSubscriptionHeaderLayout();
    scheduleRechargeOnetimePriceSync();

    // Initial keyboard binding for labels within the Recharge widget and variant groups
    bindKeyboardToLabels(document);
    syncRcVariantHighlights();
    updateVariantLabelCheckedState(document);

    // Global Enter-to-click behavior (scoped to subscription widget and variant options)
    try {
      if (!window.__enaviEnterToClickBound) {
        document.addEventListener('keydown', (ev) => {
          if (ev.key !== 'Enter') return;
          const target = ev.target;
          if (!target) return;
          // Ignore text inputs, textareas, and selects
          const tag = target.tagName;
          if (tag === 'INPUT') {
            const type = target.type && target.type.toLowerCase();
            if (['text', 'search', 'email', 'url', 'number', 'password'].includes(type)) return;
          }
          if (tag === 'TEXTAREA' || tag === 'SELECT' || target.isContentEditable) return;

          // Only within rc widget or product variant option groups
          const inScope = target.closest('.rc-widget') || target.closest('.product-form__input');
          if (!inScope) return;

          // Prefer clicking the associated label or input for radios
          let clickable = null;
          // Label with for
          const label = target.closest('label');
          if (label && label.getAttribute('for')) {
            const forId = label.getAttribute('for');
            const input = document.getElementById(forId);
            if (input) clickable = input;
            else clickable = label;
          }
          // Radio input itself
          if (!clickable) {
            const radio = target.closest('input[type="radio"]');
            if (radio) clickable = radio;
          }
          // Fallback to topmost focusable element in scope
          if (!clickable) clickable = label || target;

          if (clickable && typeof clickable.click === 'function') {
            ev.preventDefault();
            clickable.click();
            // Fire change to ensure dynamic UI updates
            if (clickable.tagName === 'INPUT' && clickable.type === 'radio') {
              try { clickable.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
              if (clickable.id) {
                document.querySelectorAll('.product-form__input label').forEach((l) => l.classList.remove('checked'));
                document.querySelectorAll(`.product-form__input label[for="${clickable.id}"]`).forEach((l) => l.classList.add('checked'));
              }
            } else if (label && label.getAttribute && label.getAttribute('for')) {
              const forId2 = label.getAttribute('for');
              const input2 = document.getElementById(forId2);
              if (input2 && input2.type === 'radio') {
                try { input2.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
                document.querySelectorAll('.product-form__input label').forEach((l) => l.classList.remove('checked'));
                document.querySelectorAll(`.product-form__input label[for="${forId2}"]`).forEach((l) => l.classList.add('checked'));
              }
            }
          }
        }, true);
        window.__enaviEnterToClickBound = true;
      }
    } catch (e) {}

    // GA: Add to Cart from buy box
    try {
      const addButtons = document.querySelectorAll('product-info [name="add"], .product__info-container [name="add"]');
      addButtons.forEach((btn) => {
        if (btn && btn.dataset.gaAtcBound !== 'true') {
          btn.addEventListener('click', () => {
            const productId = getProductIdFromPage();
            const purchaseType = getSelectedPurchaseType();
            pushAnalyticsEvent('buybox_click_atc', { product_id: productId, purchase_type: purchaseType }, 'Add to cart action from buy box');
          });
          btn.dataset.gaAtcBound = 'true';
        }
      });
    } catch (e) {}

    // Keep in sync on variant changes published by the PDP
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, () => {
          scheduleRechargeOnetimePriceSync();
        });
      }
    } catch (e) {
      // no-op if pub/sub is unavailable
    }

    // Also observe price DOM mutations for faster updates
    const priceRoot = document.querySelector('.product__info-container .price');
    if (priceRoot && typeof MutationObserver !== 'undefined') {
      const priceObserver = new MutationObserver(() => {
        scheduleRechargeOnetimePriceSync();
        const plansContainer = document.querySelector('.rc-selling-plans');
        updatePricePerPouchForContainer(plansContainer, 'sub');
        updateVariantLabelCheckedState(document);
        ensureVariantLabelAndWrapperSync(document);
        scheduleLabelSync(document);
        // Re-bind keyboard handlers in case nodes changed
        bindKeyboardToLabels(document);
      });
      priceObserver.observe(priceRoot, { childList: true, characterData: true, subtree: true });
    }

    const rechargePriceEl = document.querySelector('.subscription-radio .rc-radio__price');
    if (rechargePriceEl && typeof MutationObserver !== 'undefined') {
      const rechargeObserver = new MutationObserver(() => {
        scheduleRechargeOnetimePriceSync();
        const plansContainer = document.querySelector('.rc-selling-plans');
        updatePricePerPouchForContainer(plansContainer, 'sub');
        updateVariantLabelCheckedState(document);
        ensureVariantLabelAndWrapperSync(document);
        scheduleLabelSync(document);
        // Re-bind keyboard handlers in case nodes changed
        bindKeyboardToLabels(document);
      });
      rechargeObserver.observe(rechargePriceEl.parentElement || rechargePriceEl, { childList: true, characterData: true, subtree: true });
    }

    // Observe Recharge widget DOM changes to keep keyboard bindings intact after dynamic updates
    const rcRoot = document.querySelector('.rc-widget');
    if (rcRoot && typeof MutationObserver !== 'undefined') {
      const labelObserver = new MutationObserver(() => {
        bindKeyboardToLabels(rcRoot);
        updateVariantLabelCheckedState(rcRoot);
        ensureVariantLabelAndWrapperSync(rcRoot);
        scheduleLabelSync(rcRoot);
      });
      labelObserver.observe(rcRoot, { childList: true, subtree: true });
    }
  }

  //Discounted Price
  const rcDiscountedPriceEl = document.querySelector('.rc-radio__price')
  if(rcDiscountedPriceEl){
    const discountedPriceEl = document.querySelector('.enavi-custom-discount-price')
    if (discountedPriceEl) {
      let rcDiscountedPrice = rcDiscountedPriceEl.textContent;
      discountedPriceEl.textContent = rcDiscountedPrice;
    }
  }


// save pill //
    var rcRadioSubscriptionElement = document.querySelector('.rc-radio__subscription');
    if (rcRadioSubscriptionElement) {
    var rcRadioSubscriptionText = rcRadioSubscriptionElement.textContent;
    var save = (rcRadioSubscriptionText.split('save')[1]) || '';
    var savePillElements = document.querySelectorAll('.save-pill');
    savePillElements.forEach(function (element) {
    element.remove();
    });
    var rcRadioSubscriptionCustomElements = document.querySelectorAll('.rc-radio__subscription-custom');
    rcRadioSubscriptionCustomElements.forEach(function (element) {
    element.remove();
    });
    var subscriptionRadio = document.querySelector('.subscription-radio');
    var rcRadioSubscriptionCustom = document.createElement('span');
    rcRadioSubscriptionCustom.className = 'rc-radio__subscription-custom';
    rcRadioSubscriptionCustom.textContent = rcRadioSubscriptionText.split('save')[0] + ` save ${save}`;
    rcRadioSubscriptionElement.parentNode && rcRadioSubscriptionElement.parentNode.insertBefore(rcRadioSubscriptionCustom, rcRadioSubscriptionElement.nextSibling);
    }
    // save pill //
}
// Execute on DOMContentLoaded and pageshow in case of cache loading
let subscriptionLayoutScriptHasExecuted = false;
document.addEventListener("load", () => {
  if (!subscriptionLayoutScriptHasExecuted) {
    executeSubscriptionLayoutScript(false);
    subscriptionLayoutScriptHasExecuted = true;
  }
});
window.addEventListener("pageshow", (event) => {
  if (!subscriptionLayoutScriptHasExecuted || (event.persisted && !subscriptionLayoutScriptHasExecuted)) {
    executeSubscriptionLayoutScript(false);
    subscriptionLayoutScriptHasExecuted = true;
  }
});
